import React from 'react';

/**
 * Interface representing the props for the AnswerHeader component.
 *
 * - ansCount - The number of answers to display in the header.
 */
interface AnswerHeaderProps {
  ansCount: number;
}

/**
 * AnswerHeader component that displays a header section for the answer page.
 * It includes the number of answers and a button to ask a new question.
 *
 * @param ansCount The number of answers to display.
 */
const AnswerHeader = ({ ansCount }: AnswerHeaderProps) => (
  <div className='flex flex-col gap-4 mt-2 sm:flex-row sm:items-center sm:justify-between'>
    <div className='text-muted-foreground'>
      {ansCount} answer{ansCount !== 1 ? 's' : ''}
    </div>
  </div>
);

export default AnswerHeader;
